import { Api } from 'utils';

class QuoteTypeService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/quote-types',params),
		create: async (params?: any) => Api.createResponse('admin/quote-types/create',params),
		update: async (params?: any) => Api.createResponse('admin/quote-types/update',params),
		delete: async (params?: any) => Api.createResponse('admin/quote-types/delete',params),
		changeStatus: async (params?: any) => Api.createResponse('admin/quote-types/change-status',params),
	}

}

export default QuoteTypeService;